module.exports = __webpack_public_path__ + "media/shared/assets/img/logo-dark-8de7863edfbeeed495f51f5cfc0c1277.svg";